/**
 * localStorage that never throws (private mode, blocked storage, quota). Only per-device
 * conveniences live here: theme, language mirror and panel sizes. Everything else is on the server.
 */
export function readJson<T>(key: string, fallback: T): T {
  try {
    const raw = window.localStorage.getItem(key);
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function writeJson(key: string, value: unknown): void {
  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch {
    // Storage unavailable: the preference lasts for this visit only.
  }
}
